import { useEffect } from 'react';
import { unregisterServiceWorker } from '../util';

export const useUnregisterServiceWorker = (): void => {
  useEffect(() => {
    unregisterServiceWorker();
  }, []);
};
